import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { CustomButton, CustomTable } from '../../shared/uiComponents';
import { useCheckPermission, useScreenWidth } from '../../shared/Helpers/hooks';
import SearchBar from '../../components/SearchBar';
import { Container, Header } from '../../components/StyledComponents';
import { AdminTypes } from '../../components/Menu';
import { PERMISSIONS } from '../../App/constants';
import { BtFilters, Headers, TableBody } from './tableInfo';
import MobileView from './mobileView';

import { getCaseCoordinators } from '../../redux/State/clientSlice/userClientSlice';
import { DispatchProperties, useSelector } from '../../redux/store';
import { getBTs } from '../../redux/State/userSlice';
import { PlusIcon } from '../../shared/Assets/svg';
import { PageHeader } from '../../components/PageHeader';
import { Puzzle } from '../../shared/Assets/menuIcons';

const BT = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch<DispatchProperties>();
	const { permissionGranted } = useCheckPermission(PERMISSIONS.USER.CREATE);
	const [params] = useSearchParams();

	const page = params.get('page') || '1';
	const pageSize = params.get('pageSize') || '8';
	const orderBy = params.get('orderBy') || '';
	const direction = params.get('direction') || '';
	const searchString = params.get('search') || '';
	const caseCoordinatorId = params.get('caseCoordinatorId') || '';

	const usersData = useSelector((state) => state.user.bts);
	const loading = useSelector((state) => state.user.loading);
	const role = useSelector((state) => state.account.role);
	const isAdmin = role?.section.id === AdminTypes.admin;

	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	useEffect(() => {
		dispatch(getCaseCoordinators());
	}, [dispatch]);

	useEffect(() => {
		dispatch(
			getBTs({
				page,
				pageSize,
				orderBy,
				direction,
				searchString,
				caseCoordinatorId,
			}),
		);
	}, [page, pageSize, orderBy, direction, searchString, caseCoordinatorId, dispatch]);

	const addBtHandler = () => {
		window.localStorage.setItem('formType', AdminTypes[2]);
		navigate('/bt/new');
	};

	const headerContent = (
		<>
			{permissionGranted && <CustomButton title="Add BT" onClick={addBtHandler} startIcon={<PlusIcon />} />}
			<SearchBar style={{ marginTop: 0 }} hasFilter={isAdmin} />
			{isAdmin && <BtFilters />}
		</>
	);

	return (
		<>
			{isMobile ? (
				<MobileView {...usersData} />
			) : (
				<Container>
					<Header>
						<PageHeader icon={<Puzzle />} title="Behavior Technician" isInContainer headerContent={headerContent} />
					</Header>
					<CustomTable headers={Headers} data={usersData} TableBody={TableBody} loading={loading} />
				</Container>
			)}
		</>
	);
};

export default BT;
